import { Stack } from "@mui/material";
import { useContext } from "react";
import { ManagementCompany } from "src/pages/Admin/ManagmentCompanies/types";
import { UnknownFund } from "src/pages/Admin/UnknownFunds/types";

import Context from "../../../../context";
import ManageCompanySearchInput from "./ManageCompanySearchInput";

export default function ManageCompanyCell({ managementCompany, id }: UnknownFund) {
	const { state } = useContext(Context);

	const onChange = (newValue: ManagementCompany) => {
		state.data.map((item) => (item.id === id ? { ...item, managementCompany: newValue } : item));
	};

	return (
		<Stack sx={{ width: 400 }}>
			<ManageCompanySearchInput onChange={onChange} value={managementCompany} />
		</Stack>
	);
}
